import {
  Form,
  Button,
  Row,
  Col,
  Checkbox,
  Divider
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import CustomDropDown from "../customDropDown/customDropDown";
import {
  useForm,
} from "react-hook-form";
import {
  DatePickerField,
  DropdownField,
  Field,
  FileUploadField,
  RadioField,
  TextField,
  TextAreafield,
  CascadeDropdownField,
  ApiValues,
  ChildForm,
  SearchableField,
} from "../../types/field";
import CustomDatePicker from "../datePicker/datepicker";
import moment from "moment";
import { InputComponent } from "../input/waiverDetailsInput";
import {
  getIndexOfAccessLevel,
  getIndexOfAccessLevelFromVal,
  getIndexOfPlatformAction,
  getIndexOfPlatformActionFromVal,
  getLoggedInUserEcode,
} from "../../utils/utils";
import { AccessLevel, RowLevelAction, ReportingToUser, ExtraRecordLevelActions, platformActionLabelsType, StepAction } from "../../types/types";
import CustomFileUpload from "../../components/fileupload/fileupload";
import { Notification } from "../../components/notification/notification";
import TextAreaInput from "../../components/textArea/textArea";
import CascadeDropDown from "../../components/customDropDown/cascadeDropDown";
import { apiAliasMapper, dataApiType, evaluateCriteria, evaluateVisibilityOfAction, executeExtraAction, filterNonUpdatableFields, getAction, getApiForField, getViewApi, getViewDataForChildField, handleLoanNumberLookUp, handleOnBlurOnField, isFieldEditable, isMandatoryField, mapCreateApiToAliasNames, mapViewApiToAliasNames, refreshFieldsBasedOnVisibility, refreshFormulaFields } from "./recordDetailUtils";
import RelatedInfo from "../../components/relatedInfo/relatedInfo";
import './waiverpaymentdetails.scss'
import CommonRadioGroup from "../../components/CommonRadioGroup/CommonRadioGroup";
import { MinusCircleOutlined } from "@ant-design/icons";
import CustomDateTimePicker from "../../components/dataAndTimePicker/datetimepicker";
import CustomTImePicker from "../../components/timePicker/timePicker";
import { SearchableInputComponent } from "../../components/searchableInputComponent/searchableInputComponent";
import { AdressInputComponent } from "../../components/addressInputComponent/addressInputComponent";
import { GetRequest, PostRequest, PutRequest } from "../../utils/api";
import WaiverHeadsDetails from "./WaiverHeadsDetails";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import CustomLoader from "../loader";
import CustomIcon from "../../components/icons/CustomIcon";
import { getRegexForValidation } from "../../utils/getRegexForValidation";

interface Props {
  urlparams: Map<string, string>;
  recordId: string;
  platformAction: RowLevelAction;
  createApi: string;
  dataApi: string;
  dataApis?: dataApiType[];
  dataApiMapper?: apiAliasMapper[];
  createApiMapper?: apiAliasMapper[];
  viewApi?: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  editForm: any;
  setOpen: Function;
  dependantFields?: any;
  userAccessLevel: AccessLevel;
  parentEntity?: string;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable?: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  mulitiDependency?: boolean,
  title?: string
  paymentModeList?: any[];
  viewPageBluPrint: any;
  extraActionsOnRecord?: ExtraRecordLevelActions[];
  platformActionLabels?: platformActionLabelsType[];
  hideActions?: Array<string>;
  enableStepNext?: boolean;
  enableStepSubmit?: boolean;
  enableStepBack?: boolean;
  onStepAction?: Function;
  extraActionsOnRecordCallback?: Function;
}

interface WaiverHeadsAmounts {
  key: string;
  componentCode?: number;
  originalAmount?: number;
  collectedAmount?: number;
  excludeInTotal?: boolean;
}

interface WaiverApprovalsInfo {
  bucket?: string,
  minWaiverPercentage?: number,
  componentCode: number,
  platformPojoName: string,
  authorityRole?: string,
  maxWaiverAmount?: number,
  minWaiverAmount?: number,
  maxWaiverPercentage?: number
}

const WaiverPaymentDetails: React.FC<Props> = ({
  recordId,
  editForm,
  dataApi,
  dataApis,
  urlparams,
  viewPageBluPrint,
  viewApi = getViewApi(dataApis, dataApi, urlparams),
  createApi,
  isCreateFlow,
  isRelatedInfo,
  setOpen,
  dependantFields,
  userAccessLevel,
  platformAction,
  parentEntity = undefined,
  recordIds,
  loanNos,
  customerNames,
  refreshTable = () => { },
  allowEdits,
  selectedRows,
  moduleCode,
  mulitiDependency,
  title,
  paymentModeList,
  dataApiMapper,
  createApiMapper,
  extraActionsOnRecord,
  hideActions,
  platformActionLabels,
  enableStepNext,
  enableStepSubmit,
  enableStepBack,
  onStepAction,
  extraActionsOnRecordCallback
}) => {
  const [formSchema, setFormSchema] = useState<Field[]>([]);
  const [loading, setLoading] = useState<Boolean>(false);
  const [formValues, setFormValues] = useState<any>({});
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>({});
  const [hideEdit, setHideEdit] = useState(false);
  const [upwardReportingUserData, setUpwardReportingUserData] = useState<ReportingToUser[]>([]);
  const [finalApprovingAuthorityUser, setFinalApprovingAuthorityUser] = useState<ReportingToUser>();
  const [waiverMatrixData, setWaiverMatrixData] = useState<WaiverApprovalsInfo[]>([]);
  const [waiverHeadFieldAmounts, setWaiverHeadFieldAmounts] = useState<WaiverHeadsAmounts[]>([]);
  const [waiverTotalHeadFieldAmount, setWaiverTotalHeadFieldAmount] = useState<WaiverHeadsAmounts>({ key: "totalDues", originalAmount: 0, collectedAmount: 0 });

  const [addedChildForms, setAddedChildForms] = useState<Map<string, Array<number>>>(new Map());
  const [removedChildForms, setRemovedChildForms] = useState<Map<string, Array<number>>>(new Map());

  const [selectCheckBox, setSelectCheckBox] = useState(false);

  const [saveLoading, setSaveLoading] = useState(false);


  const {
    handleSubmit,
    resetField,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    trigger
  } = useForm<any>({});

  useEffect(() => {
    if (
      viewApi?.length > 0 &&
      (!isCreateFlow ||
        getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ||
        isRelatedInfo)
    ) {
      setLoading(true);
      getViewData(viewApi, recordId)
        .then((data: any) => {
          setViewData(mapViewApiToAliasNames(data, dataApiMapper));
          editForm.filter((field: Field) => field.display === false).forEach((field: Field) => {
            setValue(field.field, data[field.field]);
          });
          setWaiverHeadFieldAmounts(editForm.filter((field: Field) => field.childField)
            .map((field: Field) => { return { key: field.field, originalAmount: data[field.childField[0].field], collectedAmount: data[field.childField[1].field], excludeInTotal: field.excludeInTotal ?? false } }));
          setLoading(false);
        });
    }
    if (formSchema?.length > 0 && isCreateFlow) {

      // setDefaultValueForCreateflow();
    }
  }, [viewApi, recordId]);

  useEffect(() => {
    computeTotal();
  }, [waiverHeadFieldAmounts])

  // const removeCollectionBreakUp = (collectionNatureTypeField: DropdownField, collectionNatureAmount: TextField) => {

  //   let formData = [...formSchema];
  //   unregister(collectionNatureTypeField.field);
  //   unregister(collectionNatureAmount.field);
  //   setFormSchema(formData.filter(field => field !== collectionNatureTypeField && field !== collectionNatureAmount));
  // };

  const getAddButtonForChildForm = (parentField: Field) => (

    <Button variant="outlined" color="primary" onClick={() => {
      const tempChildForm: Map<string, Array<number>> = new Map(removedChildForms);
      let currentAdded: Array<number> = [...addedChildForms.get(parentField.field) ?? [0]];
      currentAdded.push(currentAdded.length);
      tempChildForm.set(parentField.field, currentAdded);
      setAddedChildForms(tempChildForm);
    }}>
      <CustomIcon height="18" width="18" className="mr-1" name="add"></CustomIcon> Add
    </Button>



  );

  const getRemoveButtonForChildForm = (parentField: Field, index: number) => (
    index > 0 ? (
      <>
        <Divider></Divider>
        {(<div className={"remove-icon-childform"}>
          <Form.Item hidden={index === 0} className={"remove-icon-form-item"}>
            <MinusCircleOutlined
              onClick={() => {
                const tempChildForm: Map<string, Array<number>> = new Map(removedChildForms);
                let currentRemoved: Array<number> = [...removedChildForms.get(parentField.field) ?? []];
                currentRemoved.push(index);
                tempChildForm.set(parentField.field, currentRemoved);
                setRemovedChildForms(tempChildForm);
                setValue(parentField.field + "[" + index + "]", undefined);
              }} rev={undefined} />
          </Form.Item>
        </div>)}
      </>
    ) : <></>
  );

  const renderChildForm = (parentField: ChildForm) => {

    if (parentField.displayType === "panel-labels") {
      return (
        <>
          <Col span={24}>
            <RelatedInfo
              urlparams={urlparams}
              bluprintSections={parentField.detailSections ?? []}
              sectionsBlueprintApis={parentField.relatedInfoBlueprintApi ?? []}
              viewHideEmptyFields={false}
              showSearch={parentField.relatedInfoShowSearch ?? false}
            ></RelatedInfo>
          </Col>
        </>
      );
    }

    return (
      <>
        <div className="w-100">

          <div className="subHeading text-base my-2 mx-2 font-semibold">
            {parentField.displayName ?? ""}
          </div>

          {Array.from(addedChildForms.get(parentField.field) ?? [0]).filter((index) => !(removedChildForms.get(parentField.field) ?? []).includes(index)).map((index) => {
            return (
              <div>
                {getRemoveButtonForChildForm(parentField, index)}
                <Row className="w-100" gutter={16}>
                  {parentField.editFields?.map((field: Field) => {
                    const fieldClone = { ...field, field: parentField.field + "[" + index + "]." + field.field };
                    return (
                      <Col span={24} lg={8} sm={24} xs={24}>
                        {renderField(fieldClone, 24, 24, 24)}
                      </Col>
                    );
                  })}
                </Row>
              </div>
            );
          })}

          <div className="text-center mt-2">
            {getAddButtonForChildForm(parentField)}
          </div>

        </div>
      </>
    );
  }

  // this doesnt need to take a redux route as its redundant to store in global state.
  const getViewData = (endpoint: string, recordId?: string): Promise<Response> => {


    endpoint = refineApiWithUrlParams(endpoint, urlparams);
    return GetRequest(endpoint);

  };

  const { t } = useTranslation();


  // reconverted to redux as this is dependant on table
  const CreateNewRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {

    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PostRequest(endpoint, data, moduleCode);

        if (moduleCode === "waiverSettlement") {
          let finalApprEcode = data["waiverSettlement"][0]["finalWaiverApprovingAuthorityEcode"];
          if (finalApprEcode === getLoggedInUserEcode()) {
            Notification("success", "Waiver details are pre-approved successfully.");
          }
        } else {
          Notification("success", "Saved Successfully");
        }

        refreshTable();
        setSaveLoading(false);
        setOpen(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              },
                { shouldFocus: true });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  // reconverted to redux as this is dependant on table
  const UpdateRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {
    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PutRequest(endpoint, filterNonUpdatableFields(data, formSchema), moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
        setIsEditClicked(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              },
                { shouldFocus: true });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  const resetFields = () => {
    if (!isCreateFlow) {
      for (const key in getValues()) {
        if (viewData.hasOwnProperty(key)) {
          const value = viewData[key];
          setValue(key, value);
          setFormValues((preVal: any) => ({
            ...preVal,
            [key]: viewData[key] || ""
          }))
        }
        else {
          setFormValues({
            [key]: ''
          })
          setValue(key, "");
        }
      }
    }
    else {
      for (const key in getValues()) {
        if (getValues().hasOwnProperty(key)) {
          setValue(key, "");
          setFormValues({})
        }
      }
      if (recordId === '' && moduleCode == '') {
        const currentDate = moment();
        const formattedDate = currentDate.format('MMM-YY').toLowerCase();
        setValue('allocationMthYr', formattedDate);
      }
    }
    getFormSchema();
  }

  const onSubmit = (data: any, event?: any) => {

    console.log(data);

    data = mapCreateApiToAliasNames(data, viewData, urlparams, createApiMapper);

    formSchema?.filter((field: Field) => field.isChildForm)
      .map((field: Field) => field as ChildForm)
      .filter((field: ChildForm) => field.displayType !== "panel-labels")
      .forEach((field: Field) => {
        data[field.field] = data[field.field].filter((singleChild: any) => singleChild !== null && singleChild !== undefined);
      });

    let fileChildEntities = formSchema
      .filter(
        (field) => field.childEntity && field.fieldType === "fileUpload"
      )
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field };
      });

    fileChildEntities.forEach(({ chilldEntity, field }) => {
      if (!data[chilldEntity!]) {
        data[chilldEntity!] = data[field];
        delete data[field];
      }
    });


    let childEntities = [...formSchema]
      .filter((field) => field.childEntity && field.fieldType !== "fileUpload")
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field, iterate: f.iterate ?? false };
      });
    childEntities.forEach(({ chilldEntity, field, iterate }) => {
      let childItems: any = [];
      if (iterate) {
        let multiValuesData: [] = Array.isArray(data[field]) ? data[field] : data[field]?.split(',');
        multiValuesData?.forEach((value) => {
          let item: any = {};
          item[field] = value;
          childItems.push(item);
        });
      } else {
        let childFormData = data[chilldEntity!]?.[0] ?? {};
        childFormData[field] = data[field];
        childItems.push(childFormData);
      }
      data[chilldEntity!] = [...childItems];
    });

    childEntities.forEach(({ chilldEntity, field }) => {
      delete data[field];
    });

    if (moduleCode === "waiverSettlement") {
      data["finalWaiverApprovingAuthorityEcode"] = finalApprovingAuthorityUser?.ecode;
      data["finalWaiverApprovingAuthority"] = (finalApprovingAuthorityUser?.ecode) ? (finalApprovingAuthorityUser?.ecode + "--" + (finalApprovingAuthorityUser?.name ?? "") + "--" + (finalApprovingAuthorityUser?.roleName ?? "")) : "";
    }

    if (parentEntity) {
      // let dat = [{ ...data }];
      let f: any = {};
      f[parentEntity] = [{ ...data }];
      data = f;
    }

    let extraActionButton: ExtraRecordLevelActions | undefined = undefined;

    let buttonActionType = undefined;
    if (event) {
      const clickedButton = event.nativeEvent.submitter;
      if (clickedButton.value && clickedButton.value !== "") {
        const buttonValue = JSON.parse(clickedButton.value);
        if (buttonValue && buttonValue.actionType === 'javascript') {
          extraActionButton = buttonValue;
        }
        if (buttonValue) {
          buttonActionType = buttonValue.actionType;
        }
      }
    }

    if (extraActionButton) {
      executeExtraAction(recordId, getValues(), urlparams, extraActionButton, refreshTable, setOpen, setError);
    }
    else if (moduleCode === "waiverApproval") {
      UpdateRecord(dataApi, recordId, data);
    } else {
      CreateNewRecord(createApi, recordId, data);
      // setIsEditClicked(false);
    }

  };



  useEffect(() => {
    if ((getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)) ||
      (getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.EDIT))) {
      setIsEditClicked(true);
    }
  }, [platformAction]);

  useEffect(() => {
    getViewData("user-hierarchy/report-to-manager/all")
      .then((data: any) => {
        let reportToManagers: ReportingToUser[] = data?.records ?? [];
        if (reportToManagers.length > 0) {
          setUpwardReportingUserData(reportToManagers);
        }
      });

    getViewData("reposession-waiver/platform/{version}/api/waiver-approval-matrix?size=100&page=0")
      .then((data: any) => {
        let waiverApprovalsInfos: WaiverApprovalsInfo[] = data.records;
        if (waiverApprovalsInfos.length > 0) {
          setWaiverMatrixData(waiverApprovalsInfos);
        }
      });

  }, []);

  const filterFormFields = () => {
    return refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, getValues, setValue, resetField, formSchema);
  };

  const getFormSchema = useCallback(() => {
    let formFields = filterFormFields();
    setFormSchema(formFields);
    formFields?.map((field: any) => {
      if (field.fieldType !== "actionButton") {
        setHideEdit(field?.editable)
      }
    });
  }, [editForm]);

  useEffect(() => {
    getFormSchema();
  }, [editForm]);

  const setInputFieldsValuesObj = () => {
    let tempInputFields: any = {};
    if (formSchema) {
      formSchema?.forEach((item: any) => {
        if (item?.field) {
          tempInputFields[item?.field] = null;
        }
      });
    }

    setFormValues(tempInputFields);

    //set default value for checkbox
    formSchema?.forEach((item: any) => {
      if (item && item.fieldType === 'checkBox') {
        setValue(item.field, getValues()[item.field] || false)
      }
    });
  };
  useEffect(() => {
    if (formSchema) {
      setInputFieldsValuesObj();
      if (waiverHeadFieldAmounts.length === 0) {
        setWaiverHeadFieldAmounts(formSchema?.filter((field: Field) => field.childField)
          .map((field: Field) => { return { key: field.field, originalAmount: 0, collectedAmount: 0 } }));
      }
    }
  }, [formSchema]);


  const handleOnChange = (value: string, field: string, option?: any) => {

    console.log(value);
    setValue(field, value);

    let currentForm = refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, getValues, setValue, resetField, formSchema);
    let formulaFields: Field[] = refreshFormulaFields(editForm, getValues, setValue, editForm);

    setFormSchema([...currentForm]);

    if (field === "settlementAmt") {
      recomputeCollectedAmount();
    }
    else {
      formulaFields.forEach((formulaField: Field) => {
        const customEvent: any = new Event('onchange');
        const detail = { field: formulaField, value: getValues()[formulaField.field] };

        customEvent.detail = detail;
        document.dispatchEvent(customEvent);
        trigger(formulaField.field);
      });
    }
  };

  const updateWaiverHeadFieldAmounts = (fieldId: string, waiverHeadFieldAmount: WaiverHeadsAmounts) => {

    setWaiverHeadFieldAmounts(waiverHeadFieldAmounts => {
      const updatedData = waiverHeadFieldAmounts.map(obj => {
        if (obj.key === fieldId) {
          return waiverHeadFieldAmount;
        }
        return obj;
      });
      return updatedData;
    });
  };
  useEffect(() => {
    // if (formValues.length === 0) {
    setFormValues(viewData);
    const tempChildForm: Map<string, Array<number>> = new Map(addedChildForms);
    editForm?.filter((field: Field) => field.isChildForm)
      .forEach((field: Field) => {
        if (viewData[field.field]) {
          let currentChildForms: Array<number> = [...addedChildForms.get(field.field) ?? []];
          if (currentChildForms.length >= viewData[field.field].length) {
            return;
          }
          while (currentChildForms.length < viewData[field.field].length) {
            currentChildForms.push(currentChildForms.length);
          }
          tempChildForm.set(field.field, currentChildForms);
        }
      });
    setAddedChildForms(tempChildForm);
    // }
  }, [viewData])

  const recomputeCollectedAmount = () => {
    let settlementAmt: number = parseFloat(getValues()["settlementAmt"]);

    if (isNaN(settlementAmt)) {
      settlementAmt = 0; // Set to 0 if the string is empty or cannot be parsed as a number
    }

    setWaiverHeadFieldAmounts(waiverHeadFieldAmounts => {
      const updatedData = waiverHeadFieldAmounts.map(obj => {
        if (settlementAmt > 0) {
          let assignCollectedTo = Math.min(obj.originalAmount ?? 0, settlementAmt);
          settlementAmt = settlementAmt - assignCollectedTo;
          return { ...obj, collectedAmount: assignCollectedTo };
        }
        return { ...obj, collectedAmount: 0 };
      });
      return updatedData;
    });
  };

  const computeTotal = () => {
    let originalAmt = waiverHeadFieldAmounts.filter(fieldHeads => fieldHeads.key !== 'totalDues' && !fieldHeads.excludeInTotal).filter(fieldHeads => !(isNaN(fieldHeads.originalAmount ?? 0))).map(fieldHeads => fieldHeads.originalAmount ?? 0).reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    let collectedAmt = waiverHeadFieldAmounts.filter(fieldHeads => fieldHeads.key !== 'totalDues' && !fieldHeads.excludeInTotal).filter(fieldHeads => !(isNaN(fieldHeads.collectedAmount ?? 0))).map(fieldHeads => fieldHeads.collectedAmount ?? 0).reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    setWaiverTotalHeadFieldAmount({ ...waiverTotalHeadFieldAmount, originalAmount: originalAmt, collectedAmount: collectedAmt });
  };

  const handleCascadeOnChange = (value: string, field: string) => {

    setValue(field, value);

    // TODO: doesnt work in internet explorer need polyfill
    // api url for cascade fields will be empty handled at client side.
    let indexOfFieldToRefresh = formSchema.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldData = editForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField == field
    );

    if (
      indexOfFieldToRefresh === -1 ||
      fieldData === null ||
      fieldData === undefined
    ) {
      return;
    }

    let fieldToRefresh = { ...formSchema[indexOfFieldToRefresh] };

    // modify api query params based on selection
    let api = fieldData.api;
    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToRefresh.api = apiWithQueryParams;

    if (viewData[fieldToRefresh.field]) {
      delete viewData[fieldToRefresh.field];
    }

    if (urlparams.has(fieldToRefresh.field)) {
      urlparams.set(fieldToRefresh.field, "");
    }

    // update field at certain index
    const newFormSchema = [...formSchema];
    newFormSchema[indexOfFieldToRefresh] = fieldToRefresh;

    // update state with new formfields
    setFormSchema(newFormSchema);
    resetField(fieldToRefresh.field);
  };

  const handleValidDateChange = (value: string, field: string) => {
    if (field === "validTill") {
      const format = "YYYY-MM-DD";
      let selectedDate = moment(value).format(format);
      getViewData("reposession-waiver/platform/{version}/api/vwWaiverDuesComponentsMapping?page=0&size=100&search=loanNo:eq{loanNo};validDate:eq" + selectedDate)
        .then((data: any) => {
          //harcoded values .. just for testing purpose
          let columnHeadSections: any[] = data.records;
          if (columnHeadSections.length > 0) {
            columnHeadSections.forEach(headSection => {

              setWaiverHeadFieldAmounts(waiverHeadFieldAmounts => {
                const updatedData = waiverHeadFieldAmounts.map(obj => {
                  if (obj.key === headSection.platformPojoKey) {
                    return { ...obj, originalAmount: headSection.originalAmt, componentCode: headSection.componentCode };
                  }
                  return obj;
                });
                return updatedData;
              });

            });
          }
          recomputeCollectedAmount();
        })
    }
  };



  //TODO: this is a temporary fix need to find a proper way to add grouped fields
  const renderTextBox = (field: TextField, span?: number, lg?: number, xs?: number) => {
    return (
      <>
        {
          field.field == 'forfeitReason' ?
            <Col span={span ?? 6} lg={12} xs={xs ?? 24}> {renderPlainTextBox(field)}
            </Col>
            :
            <Col span={span ?? 6} lg={lg ?? 6} xs={xs ?? 24}>
              {renderPlainTextBox(field)}
            </Col>
        }
      </>
    );
  };

  const renderTextBoxNoLabel = (field: TextField, span?: number, lg?: number, xs?: number, lable: boolean = true) => {
    return (
      <>
        {
          field.field == 'forfeitReason' ?
            <Col span={4}> {renderPlainTextBoxNoLabel(field)}
            </Col>
            :
            <Col span={4}>
              {renderPlainTextBoxNoLabel(field)}
            </Col>
        }
      </>
    );
  };

  // const { TextArea } = Input;

  const renderTextAreainput = (field: TextField, span?: number, lg?: number, xs?: number) => {
    // let fieldName = field?.field;
    return (
      <Col span={span ?? 6} lg={lg ?? 12} xs={xs ?? 24}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field?.rules[0]?.mandatory,
              message: "Please enter the value.",
            },
          ]}
        >
          <TextAreaInput
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={setValue}
            placeholder={field?.placeholder}
            data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            rules={field?.rules && field?.rules[0]}
            maxLength={field?.rules[0].maxSize}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderAddressField = (field: TextField) => {
    return (
      <Col span={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <AdressInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={setValue}
              placeholder={field?.placeholder}
              recordId={refineApiWithUrlParams("{loanNo}", urlparams)}
              data={viewData[field?.field] || getValues()[field.field] || field?.rules[0].default}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              rules={field?.rules && field?.rules[0]}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderSearchableInputField = (field: SearchableField) => {
    return (
      <Col span={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <SearchableInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={setValue}
              placeholder={field?.placeholder}
              data={viewData[field?.field] || getValues()[field.field] || field?.rules[0].default}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              rules={field?.rules && field?.rules[0]}
              searchModalProps={field.searchModalProps}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderPlainTextBox = (field: TextField) => {

    return (
      <div className="w-100">
        <Form.Item
          hidden={field?.hidden}
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field?.rules[0]?.mandatory,
              message: "Please enter the value.",
            },
            {
              pattern: field?.rules?.length > 0 ?  getRegexForValidation(field?.rules[0]?.allowValues).value : undefined,
              message: "Please enter valid value.",
            }
          ]}
        >
          <InputComponent
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={setValue}
            placeholder={field?.placeholder}
            data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field] || field?.rules[0].default}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            onBlur={(e: any) => {
              handleOnBlurOnField(field, setError, setValue, editForm, getValues, urlparams, {});
              return field.lookupField && field.lookupFieldEndpoint
                ? handleOnBlur(
                  e,
                  field.field,
                  field.lookupField,
                  field.lookupFieldEndpoint
                )
                : undefined
            }
            }
            onChange={(e: any) => {
              handleOnChange(e.target?.value, field?.field);
              const customEvent: any = new Event('onchange');
              const detail = { field: field, value: e.target?.value };
              if (e.target?.value == '') {
                detail.value = 0
              }
              customEvent.detail = detail;
              document.dispatchEvent(customEvent);
              trigger(field.field);
            }}
            rules={field?.rules && field?.rules[0]}
          />
        </Form.Item>
      </div>
    );
  };

  const renderPlainTextBoxNoLabel = (field: TextField) => {

    return (
      <>
        <Form.Item
          hidden={field?.hidden}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field?.rules[0]?.mandatory,
              message: "Please enter the value.",
            },
            {
              pattern: field?.rules[0]?.pattern,
              message: "Please enter valid value.",
            },
          ]}
        >
          <InputComponent
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={setValue}
            placeholder={field?.placeholder}
            data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field] || field?.rules[0].default}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            onBlur={(e: any) => {
              handleOnBlurOnField(field, setError, setValue, editForm, getValues, urlparams, {});
              return field.lookupField && field.lookupFieldEndpoint
                ? handleOnBlur(
                  e,
                  field.field,
                  field.lookupField,
                  field.lookupFieldEndpoint
                )
                : undefined
            }
            }
            onChange={(e: any) => {
              handleOnChange(e.target?.value, field?.field);
              const customEvent: any = new Event('onchange');
              const detail = { field: field, value: e.target?.value };
              if (e.target?.value == '') {
                detail.value = 0
              }
              customEvent.detail = detail;
              document.dispatchEvent(customEvent);
              trigger(field.field);
            }}
            rules={field?.rules && field?.rules[0]}
          />
        </Form.Item>
      </>
    );
  };


  const handleOnBlur = async (
    value: any,
    field: string,
    lookupField?: string,
    lookupFieldUrl?: string
  ) => {

    if (!lookupField || !lookupFieldUrl || value === "") {
      return;
    }


    handleLoanNumberLookUp(value, lookupField, lookupFieldUrl)
      .then((customerName) => {

        setValue(lookupField, customerName);
        clearErrors(field);
      })
      .catch((error) => {
        setError(field, error);
      });
  };


  const renderDropDown = (field: DropdownField, span?: number, lg?: number, xs?: number) => {

    const apiValue: ApiValues = getApiForField(editForm, getValues, field);
    return (
      <Col span={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <div className="dropdown-custom">
            <CustomDropDown
              name={field?.field}
              title={field?.displayName}
              control={control}
              setValue={setValue}
              // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => {
                console.log(val);
                handleOnChange(val, field?.field);
              }}
              api={refineApiWithUrlParams(apiValue.api, urlparams)}
              rules={field?.rules[0]}
              dropdownCode={apiValue.dropdownCode}
              dropdownValue={apiValue.dropdownValue}
              placeholder={field?.placeholder}
              showOnlyValue={field?.rules[0].showOnlyValue}
              data={field?.field.includes(".") ? getViewDataForChildField(getValues() || viewData, field?.field) : (getValues()[field?.field] || viewData[field?.field]) }
              staticDropDownValues={field.staticDropDownValues ?? []}
            />
          </div>
        </Form.Item>
      </Col>
    );
  };

  const renderCascadeDropDown = (field: CascadeDropdownField, span?: number, lg?: number, xs?: number) => {
    return (
      <Col span={span ?? 12} lg={lg ?? 12} xs={xs ?? 12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CascadeDropDown
            name={field?.field}
            title={field?.displayName}
            control={control}
            setValue={setValue}
            data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            onChange={(val: any) => {
              handleCascadeOnChange(val, field?.field);
            }}
            api={""}
            //   api={refineApiWithUrlParams(field.api)}
            rules={field?.rules[0]}
            dropdownCode={field?.dropdownCode}
            dropdownValue={field?.dropdownValue}
            placeholder={field?.placeholder}
            isCascade={
              field.valuesDependOnField !== undefined &&
              field.valuesDependOnField !== null &&
              field.valuesDependOnField !== ""
            }
            showOnlyValue={field?.rules[0]?.showOnlyValue}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderCalender = (field: DatePickerField, span?: number, lg?: number, xs?: number) => {
    return (
      <Col span={span ?? 6} lg={lg ?? 6} xs={xs ?? 24}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDatePicker
            title={field?.displayName}
            data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => {

              setFormValues({
                ...formValues,
                [field?.field]: e
              });

              setValue(field.field, e);
              handleValidDateChange(e, field?.field);

            }}

            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={setValue}
            name={field.field}
            id={field.field}
            currentValue={formValues[field?.field]}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderFileUpload = (field: any, span?: number, lg?: number, xs?: number) => {

    var rules = { ...field.rules[0] };
    rules.fileContext = dependantFields[0]?.field as string;

    return (
      <>
        <Col span={24} lg={12} >
          <Form.Item
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: field.rules[0].mandatory,
                message: "Please select the value.",
              },
            ]}
          >

            <CustomFileUpload
              width={200}
              title={field?.displayName}
              data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(files: any) => {
                if (field.childEntity) {
                  setValue(field.childEntity, files);
                } else {
                  setValue(field.field, files[0].fileName);
                }
              }
              }
              rules={rules}
              placeholder={field?.placeholder}
              control={control}
              setValue={setValue}
              uploadApi={field.api}
              maxFilesAllowed={field.rules[0].maxFilesAllowed}
              name={field.field}
              id={field.field}
              childEntity={field.childEntity}
              downloadApi={field.downloadApi}
              uploadedFileList={viewData[field?.childEntity ?? ""]}
              getValue={getValues}
            />
          </Form.Item>

        </Col>
      </>
    );
  };


  const renderSubHeading = (field: any, span?: number, lg?: number, xs?: number) => {
    return (
      <Col span={span ?? 6} lg={lg ?? 6} xs={xs ?? 24}>
        <p className="subHeading text-base my-2 mx-2 font-semibold">
          {field.displayName}
        </p>
      </Col>
    )
  }

  const renderCalenderWithTime = (field: any) => {
    return (
      <Col span={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDateTimePicker
            title={field?.displayName}
            data={getValues()[field?.field] || viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}

            onChange={(e: any) => {

              setValue(field.field, e);

              setFormValues({
                ...formValues,
                [field?.field]: e
              });

            }

            }

            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={setValue}
            name={field.field}
            id={field.field}
            currentValue={formValues[field?.field]}
          />
        </Form.Item>
      </Col>
    );
  };
  const renderCalenderTime = (field: any) => {
    return (
      <Col span={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomTImePicker
            title={field?.displayName}
            data={getValues()[field?.field] || viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => setFormValues({
              ...formValues,
              [field?.field]: e
            }
            )}
            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={setValue}
            name={field.field}
            id={field.field}
            currentValue={formValues[field?.field]}
          />
        </Form.Item>
      </Col>
    );
  };


  const renderRadio = (field: RadioField, span?: number, lg?: number, xs?: number) => {
    console.log(viewData[field?.field]);
    return (
      <Col span={span ?? 6} lg={lg ?? 6} xs={xs ?? 24}>
        <Form.Item
          label={field.hideLabel ? null : t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CommonRadioGroup
            title={field?.displayName}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            // disabled={false}
            rules={field?.rules[0]}
            api={field.api ?? ""}
            placeholder={field?.placeholder}
            control={control}
            setValue={setValue}
            name={field.field}
            options={field.values}
            data={(field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field] || getValues()[field.field] ) ?? field.rules[0].default}
            // value={getValues()[field.field]}
            // data={getValues()[field.field]}
            onChange={(e: any) => handleOnChange(e.target?.value, field?.field)}
            uiType={field.uiType}
          />
        </Form.Item>
      </Col>
    );
  };

  const getDefaultChecked = (field: any): boolean => {
    setValue(field?.field, viewData[field?.field]);
    return viewData[field?.field];
  }

  const renderCheckBox = (field: any, span?: number, lg?: number, xs?: number) => {
    let fieldName = field?.field;
    return (
      <Col span={span ?? 6} lg={lg ?? 6} xs={xs ?? 24}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <Checkbox
            type={"checkbox"}
            checked={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            defaultChecked={getDefaultChecked(field)}
            onChange={(e: any) => {
              setValue(fieldName, e.target?.checked);
              setFormValues({
                ...formValues,
                [fieldName]: e.target?.checked,
              });
              setViewData({
                ...viewData,
                [fieldName]: e.target?.checked,
              });
              handleOnChange(e.target?.value, field?.field)
            }}
            name={field.field}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
          ></Checkbox>
        </Form.Item>
      </Col>
    );
  };

  // TODO: use enum instead of strings
  const renderField = (field: Field, span?: number, lg?: number, xs?: number) => {
    if (field.display === false) {
      return;
    }

    if (field.hasOwnProperty("childForm")) {
      span = 4;
    } else {
      span = 6;
    }


    if (selectCheckBox && (getValues()?.[field?.field] == '' || getValues()?.[field?.field] == undefined))
      return
    // if (field?.childField)
    //   return
    if (field?.rules && field?.rules[0]) {
      field.rules[0].mandatory = isMandatoryField(field, getValues, editForm);
    }

    switch (field.fieldType) {
      case "textBox":
        return renderTextBox(field as TextField, span, lg, xs);
      case "formula":
        return renderTextBox(field as TextField);
      case "textArea":
        return renderTextAreainput(field as TextAreafield, span, lg, xs);
      case "address":
        return renderAddressField(field as TextField);
      case "searchableField":
        return renderSearchableInputField(field as SearchableField);
      case "dropDown":
        return renderDropDown(field as DropdownField, span, lg, xs);
      case "cascadeDropDown":
        return renderCascadeDropDown(field as CascadeDropdownField, span, lg, xs);
      case "calendar":
        return renderCalender(field as DatePickerField, span, lg, xs);
      case "radio":
        return renderRadio(field as RadioField, span, lg, xs);
      case "checkBox":
        return renderCheckBox(field as any, span, lg, xs);
      case "fileUpload":
        return renderFileUpload(field as FileUploadField, span, lg, xs);
      case "subHeading":
        return renderSubHeading(field as any, span, lg, xs)
      case "calendarWithTime":
        return renderCalenderWithTime(field as any)
      case "CalendarOnlyTime":
        return renderCalenderTime(field as any)
      // case "denomination":
      //   return renderDenominationField(field as DenominationField);
    }
  };

  // TODO: use enum instead of strings
  const renderFieldDesktop = (field: Field, span?: number, lg?: number, xs?: number) => {
    if (field.display === false) {
      return;
    }

    span = 4;

    if (selectCheckBox && (getValues()?.[field?.field] == '' || getValues()?.[field?.field] == undefined))
      return
    // if (field?.childField)
    //   return
    if (field?.rules && field?.rules[0]) {
      field.rules[0].mandatory = isMandatoryField(field, getValues, editForm);
    }

    switch (field.fieldType) {
      case "textBox":
        return renderTextBoxNoLabel(field as TextField, span, lg, xs);
      case "formula":
        return renderTextBoxNoLabel(field as TextField);
      case "textArea":
        return renderTextAreainput(field as TextAreafield, span, lg, xs);
      case "address":
        return renderAddressField(field as TextField);
      case "searchableField":
        return renderSearchableInputField(field as SearchableField);
      case "dropDown":
        return renderDropDown(field as DropdownField, span, lg, xs);
      case "cascadeDropDown":
        return renderCascadeDropDown(field as CascadeDropdownField, span, lg, xs);
      case "calendar":
        return renderCalender(field as DatePickerField, span, lg, xs);
      case "radio":
        return renderRadio(field as RadioField, span, lg, xs);
      case "checkBox":
        return renderCheckBox(field as any, span, lg, xs);
      case "fileUpload":
        return renderFileUpload(field as FileUploadField, span, lg, xs);
      case "subHeading":
        return renderSubHeading(field as any, span, lg, xs)
      case "calendarWithTime":
        return renderCalenderWithTime(field as any)
      case "CalendarOnlyTime":
        return renderCalenderTime(field as any)
      // case "denomination":
      //   return renderDenominationField(field as DenominationField);
    }
  };





  const renderActions = () =>
    formSchema?.map((field: Field) => {
      switch (field.fieldType) {
        case "actionButton":
          return getAction(userAccessLevel, viewPageBluPrint, moduleCode, urlparams, field.actionInfo, field.displayName);
      }
    });


  const renderFinalApprovingAuthority = () => {
    return finalApprovingAuthorityUser ? (
      <div className="waiver-head-note mx-3 px-2 rounded">
        <span className="font-medium">Final Approving Authority : </span>
        <span className="font-semibold">
          {finalApprovingAuthorityUser.ecode} - {finalApprovingAuthorityUser.name} ({finalApprovingAuthorityUser.roleName})
        </span>
      </div>
    ) : <></>;
  }

  const computeFinalApprovingAuthority = () => {
    let finalApprovingAuth: ReportingToUser | undefined;
    const approvingHeadFields = new Set(formSchema?.filter((field: Field) => field.childField && field.childField.length > 4)
      .map((field: Field) => getValues()[field.childField[4].field])
      .map((field: string) => (field && field.split("--")) ? field.split("--")[0] : field));

    for (const reportingUser of upwardReportingUserData) {
      if (approvingHeadFields.has(reportingUser.ecode)) {
        finalApprovingAuth = reportingUser;
        break;
      }
    }
    setFinalApprovingAuthorityUser(finalApprovingAuth);
  }

  //
  const renderFields = () => {



    let topLablesShown = 1;

    return (
      <>

        <Row className="" gutter={16}>


          {formSchema?.map((field: Field, index: number) => {



            if (field.isChildForm) {
              return renderChildForm(field as ChildForm);
            }

            else if (field.childField) {  // field has child fields

              if (isMobile) {

                if (field.isChildForm) {
                  return renderChildForm(field as ChildForm);
                }

                else if (field.childField) {
                  if (field.field === 'totalDues') {
                    return <WaiverHeadsDetails
                      fields={field.childField}
                      renderField={renderField}
                      getValue={getValues}
                      bucket={urlparams.get("dpdBucket")}
                      setValue={setValue}
                      waiverHeadFieldAmount={waiverTotalHeadFieldAmount}
                      waiverApprovalMatrix={waiverMatrixData}
                      reportingToUsers={upwardReportingUserData}
                      moduleCode={moduleCode}
                      viewData={viewData}></WaiverHeadsDetails>
                  } else {
                    return <WaiverHeadsDetails
                      fields={field.childField}
                      renderField={renderField}
                      updateWaiverHeadFieldAmounts={updateWaiverHeadFieldAmounts}
                      getValue={getValues}
                      setValue={setValue}
                      bucket={urlparams.get("dpdBucket")}
                      waiverSettlementStatus={urlparams.get("waiverStatus")}
                      waiverHeadFieldAmount={waiverHeadFieldAmounts.find(amountField => amountField.key === field.childField[0].field) ?? { key: field.childField[0].field, originalAmount: 0, collectedAmount: 0 }}
                      waiverApprovalMatrix={waiverMatrixData}
                      reportingToUsers={upwardReportingUserData}
                      moduleCode={moduleCode}
                      viewData={viewData}
                      recomputeCollectedAmount={recomputeCollectedAmount}
                      onUpdateOfAuthorityEcode={computeFinalApprovingAuthority}></WaiverHeadsDetails>
                  }
                }
                else {
                  return renderField(field)
                }
              } else {

                if (field.field === 'totalDues') {
                  return <Row className="w-100 my-1" justify="space-between">
                    <Col span={6} className="font-medium text-left pl-2"><label>{field.displayName}</label></Col><WaiverHeadsDetails
                      fields={field.childField}
                      renderField={renderFieldDesktop}
                      getValue={getValues}
                      bucket={urlparams.get("dpdBucket")}
                      setValue={setValue}
                      waiverHeadFieldAmount={waiverTotalHeadFieldAmount}
                      waiverApprovalMatrix={waiverMatrixData}
                      reportingToUsers={upwardReportingUserData}
                      moduleCode={moduleCode}
                      viewData={viewData}></WaiverHeadsDetails></Row>
                }

                topLablesShown = topLablesShown - 1;
                return <>
                  {topLablesShown == 0 && <Row className="mt-2 mb-2 w-100 text-primary" justify="space-between">
                    <Col span={6} className="font-medium text-center text-primary"><label> {t("Name")} </label>  </Col>
                    <Col span={4} className="font-medium text-center text-primary"> <label> {t("Amount")} </label> </Col>
                    <Col span={4} className="font-medium text-center text-primary"> <label> {t("Collected")}</label>  </Col>
                    <Col span={4} className="font-medium text-center text-primary"> <label> {t("Waiver")}</label>  </Col>
                    <Col span={4} className="font-medium text-center text-primary"> <label> {t("Wavier %")}</label>  </Col>
                  </Row>}

                  <Row className="w-100 my-1" justify="space-between">
                    <Col span={6} className="font-medium text-left pl-2">
                      <label className="text-primary">{field.displayName}</label></Col>
                    <WaiverHeadsDetails
                      fields={field.childField}
                      renderField={renderFieldDesktop}
                      updateWaiverHeadFieldAmounts={updateWaiverHeadFieldAmounts}
                      getValue={getValues}
                      setValue={setValue}
                      bucket={urlparams.get("dpdBucket")}
                      waiverSettlementStatus={urlparams.get("waiverStatus")}
                      waiverHeadFieldAmount={waiverHeadFieldAmounts.find(amountField => amountField.key === field.childField[0].field) ?? { key: field.childField[0].field, originalAmount: 0, collectedAmount: 0 }}
                      waiverApprovalMatrix={waiverMatrixData}
                      reportingToUsers={upwardReportingUserData}
                      moduleCode={moduleCode}
                      viewData={viewData}
                      recomputeCollectedAmount={recomputeCollectedAmount}
                      onUpdateOfAuthorityEcode={computeFinalApprovingAuthority}></WaiverHeadsDetails>
                  </Row>

                </>

              }


            } else {

              return renderField(field);
            }

          })}





        </Row>
      </>
    )
  }


  const renderPlatformAction = (actionName: string): boolean | undefined => {
    const criteria = (platformActionLabels?.find(actionLabel => actionLabel.actionName === "Save")?.visibilityCriteria);
    const hideAction: boolean | undefined = (hideActions?.find(action => action === actionName) !== undefined || enableStepNext || enableStepSubmit);
    if (!evaluateCriteria(criteria, editForm, getValues, urlparams) || hideAction) {
      return false;
    }
    return true;
  };


  const createEditFields = (): any => {
    if (loading) {
      return (<div className="panel-loading">
        <CustomLoader></CustomLoader>
      </div>);
    }
    else if (formSchema) {
      return (
        <>
          <form onSubmit={handleSubmit(onSubmit)} className="ant-form ant-form-vertical w-100">
         
            <Row>{renderFields()}</Row>
            <Row>{renderFinalApprovingAuthority()}</Row>
            {getIndexOfAccessLevel(userAccessLevel) >
              getIndexOfAccessLevelFromVal(AccessLevel.READ) && allowEdits ? (
              footer()
            ) : (
              <></>
            )}
            <div style={{ textAlign: 'right' }}>
              {viewPageBluPrint?.hideEmptyFeilds && (<Checkbox checked={selectCheckBox}
                onChange={() => setSelectCheckBox(!selectCheckBox)}>Hide Empty Field</Checkbox>)}
            </div>

          </form>

          <>{renderActions()}</>
        </>
      );
    }
  }
    ;

  const footer = () =>
    <div className="button-container text-right mx-3 mt-2">
      <>
        <>
          {
            (enableStepBack ? (<Button className="button-custom-margin" type="default" onClick={() => onStepAction && onStepAction(StepAction.BACK)}>
              {"Back"}
            </Button>) : (<></>))
          }
          {
            (enableStepNext ? (<Button className="button-custom-margin" type="primary" htmlType="submit" value={JSON.stringify({ "actionType": "stepActionNext" })}>
              {"Save & Continue"}
            </Button>) : (<></>))
          }
          {
            (enableStepSubmit ? (<Button className="button-custom-margin" type="primary" htmlType="submit" value={JSON.stringify({ "actionType": "stepActionSubmit" })}>
              {"Submit"}
            </Button>) : (<></>))
          }
          {
            (isEditClicked || isCreateFlow ? (
              <div style={{ display: "inline-block" }}>
                {!renderPlatformAction("Save") ? <></> :
                  <Button className="button-custom-margin" type="primary" htmlType="submit" loading={saveLoading}>
                    {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Save")?.label) ?? "Recommend"}
                  </Button>}

                {(viewPageBluPrint.resetButton !== true) ? <></> :
                  <Button className="button-custom-margin" type="primary" htmlType="button"
                    onClick={() => resetFields()}
                  >
                    Reset
                  </Button>}

                {!renderPlatformAction("Cancel") ? <></> :
                  <Button
                    className="button-custom-margin"
                    type="default"
                    hidden={isCreateFlow || getIndexOfPlatformAction(platformAction) ===
                      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)}
                    onClick={() => setIsEditClicked(false)}
                  >
                    {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Cancel")?.label) ?? "Cancel"}
                  </Button>}

              </div>
            ) : (
              !renderPlatformAction("Edit") || getIndexOfAccessLevel(userAccessLevel) < getIndexOfAccessLevelFromVal(AccessLevel.EDIT) ? <></> :
                hideEdit && <Button type="primary" onClick={() => setIsEditClicked(true)}>
                  {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Edit")?.label) ?? "Edit"}
                </Button>
            ))
          }
        </>
        {/* <div className={"extra-actions-footer"}> */}
        {
          extraActionsOnRecord?.filter(extraAction => evaluateVisibilityOfAction(extraAction, editForm, getValues, urlparams))
            ?.filter(extraAction => extraAction.action ? (getIndexOfPlatformAction(platformAction) ===
              getIndexOfPlatformActionFromVal(extraAction.action)) : true)
            .map(extraAction => {
              if (extraAction.actionType === "modal") {
                return getAction(userAccessLevel, viewPageBluPrint, moduleCode, urlparams, { type: "modal", blueprintApi: extraAction.blueprintApi, title: extraAction.actionName, launchMode: extraAction.launchMode }, extraAction.actionName, (val) => { refreshTable(); setOpen(false); });
              } else {
                return (<Button className="button" style={{ marginLeft: "10px", display: "inline-block" }} value={JSON.stringify(extraAction)} htmlType={extraAction.performFormValidation ? "submit" : "button"} type="primary" onClick={() => {
                  if (extraActionsOnRecordCallback) {
                    extraActionsOnRecordCallback(viewData, extraAction);
                  } else if (extraAction.performFormValidation) {
                    console.log("it is going to submit the form.");
                  } else {
                    executeExtraAction(recordId, getValues(), urlparams, extraAction, refreshTable, setOpen, setError);
                  }
                }}>
                  {extraAction.actionName}
                </Button>);
              }
            })
        }
        {/* </div> */}
      </>
    </div>

  return createEditFields();
};

export default WaiverPaymentDetails;
